exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart_shipping_price>div[data-v-0e086d03]{display:inline;font-size:14px;font-weight:700}.bt_total_num[data-v-0e086d03]{line-height:19px;height:100%;padding:7px 0}.bt_total_num span.include-shipping[data-v-0e086d03]{font-size:12px;display:block}", ""]);

// exports
